import { defineComponent as _defineComponent } from 'vue'
import JudgingPoint from '@/components/Battle/Prelims/JudgingPoint.vue'
import { IParticipant, PrelimsJudgment } from '@/types/battle'
import { onMounted, ref } from 'vue'
import { mdiChevronDown, mdiChevronUp, mdiStarOutline } from '@mdi/js'
import { IEvent } from '@/enitites/event'
import { useImage } from '@/shared/composables/image'
import api from '@/api'


export default /*#__PURE__*/_defineComponent({
  __name: 'PrelimsRoundScoreParticipants',
  props: {
    participant: null,
    battleId: null,
    canEdit: { type: Boolean },
    canSetGone: { type: Boolean },
    isHighlighted: { type: Boolean },
    isGrayedOut: { type: Boolean },
    isCrew: { type: Boolean },
    event: null,
    judgment: null
  },
  emits: ["cancel", "gone", "edit", "update:prelims"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'cancel'): void
  (e: 'gone', id: number): void
  (e: 'edit'): void
  (e: 'update:prelims', value: unknown): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  participant: IParticipant
  battleId: number
  canEdit: boolean
  canSetGone: boolean
  isHighlighted: boolean
  isGrayedOut: boolean
  isCrew?: boolean
  event: IEvent
  judgment: PrelimsJudgment
};


const { getAvatar } = useImage()

const roundsForJudgment = ref({
  0: props.judgment,
})

const judgment = ref(props.judgment)

const rounds = ref(
  Object.keys(roundsForJudgment.value).map((key) => ({
    round: Number(key),
    name: 'Round',
    judment: roundsForJudgment.value[key],
  }))
)



const isEditMode = ref(false)
const isShowActions = ref(false)
const availableMainPoints = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
const isPointDetailsOpened = ref(false)
const loading = ref(false)
const isShowDoneButton = ref(false)

async function updatePoints() {
  loading.value = true
  const updatedPrelims = await api.prelims.setJudgment(props.battleId, [judgment.value])

  loading.value = false
  if (!updatedPrelims) return
  emit('update:prelims', updatedPrelims)
}

function toggleEditMode() {
  if (isEditMode.value) {
    isEditMode.value = false
    isShowActions.value = false
    isShowDoneButton.value = false
    emit('cancel')
    updatePoints()
  } else {
    isEditMode.value = true
    isShowActions.value = true
    isShowDoneButton.value = true
    emit('edit')
  }
}

const isExistPoints = !!props.judgment.points

function selectMainPoint(point: number, index: number) {
  const prevPoint = rounds.value[index].judment.points || 0
  const diff = point - Math.floor(prevPoint)
  rounds.value[index].judment.points += diff || -point

  if (isExistPoints) return
  updatePoints()
}

function selectHalfPoint() {
  if (Number.isSafeInteger(rounds.value[0].judment.points)) {
    rounds.value[0].judment.points += 0.5
  } else {
    rounds.value[0].judment.points -= 0.5
  }
  if (isExistPoints) return
  updatePoints()
}

onMounted(() => {
  if (props.judgment && !props.judgment.points && props.canEdit) {
    isEditMode.value = true
    emit('edit')
  }
})

return { __sfc: true,props, getAvatar, roundsForJudgment, judgment, rounds, emit, isEditMode, isShowActions, availableMainPoints, isPointDetailsOpened, loading, isShowDoneButton, updatePoints, toggleEditMode, isExistPoints, selectMainPoint, selectHalfPoint, JudgingPoint, mdiChevronDown, mdiChevronUp, mdiStarOutline }
}

})